import ClientWorkOrderList from "../../views/CustomerWorkOrder/CustomerWorkOrderList";

const ClientWorkOrderPage = () => {
  return <ClientWorkOrderList />;
};

export default ClientWorkOrderPage;
